import { Switch } from 'antd';
import styled from 'styled-components';
import { pickThemeColor } from '@/theme';

export const StyledSwitch = styled(Switch)`
  &&&.ant-switch-checked {
    background-color: ${pickThemeColor('DARK_GREEN')};
  }
`;
